/** * * Asynchronously loads the component for
SwapVoice
* */ import { lazyLoad } from "utils/loadable";
export const SwapVoice = lazyLoad(
  () => import("./index"),
  (module) => module.SwapVoice
);
